import { RawUser, User } from '../types/index';

import { supabase } from './supabase';

export async function fetchTeamMembers(
  teamMemberIds: string[],
  userType: string | undefined,
): Promise<User[]> {
  if (!teamMemberIds?.length) {
    return [];
  }

  let query = supabase
    .from('users')
    .select(
      `
      id,
      first_name,
      last_name,
      avatar_url,
      email,
      employee_id,
      shadow_to
    `,
    )
    .in('id', teamMemberIds)
    .eq('type', 'internal');

  if (userType === 'external') {
    query = query.not('role', 'eq', 'shadow_engineer');
  }

  const { data, error } = await query.order('first_name', { ascending: true });

  if (error) {
    throw new Error(`Failed to fetch team members: ${error.message}`);
  }

  if (!data) {
    throw new Error('No data returned from team members query');
  }

  return data.map((user: RawUser) => ({
    id: user.id,
    firstName: user.first_name,
    lastName: user.last_name,
    avatarUrl: user.avatar_url || undefined,
    email: user.email,
    employeeId: user.employee_id,
    shadowTo: user.shadow_to,
  }));
}
